<!-- eslint-disable no-undef -->
<script setup>
  import { useRoute } from 'vue-router';

  defineOptions({
    name: 'PrimaryDomainNav'
  });

  const props = defineProps({
    items: {
      type: Array,
      default: () => []
    }
  });

  const route = useRoute();

  const isActive = (itemPath) => route.path.startsWith(itemPath);
</script>

<template>
  <aside
    class="hidden bg-mc-ink text-mc-white lg:flex lg:w-52 lg:flex-col lg:gap-2 lg:p-3"
    :style="{ borderRight: '1px solid var(--line-on-dark)' }"
    aria-label="Primary domain navigation"
  >
    <RouterLink
      v-for="item in props.items"
      :key="item.id"
      :to="item.to"
      class="rounded-md px-3 py-2 text-sm font-medium text-white/82 transition-colors hover:bg-white/10 hover:text-white"
      :class="isActive(item.to) ? 'bg-white/10 text-white' : ''"
      :aria-current="isActive(item.to) ? 'page' : undefined"
    >
      {{ item.label }}
    </RouterLink>
  </aside>
</template>
